// src/useAppVersionCheck.js
import { useEffect } from "react";
import { APP_VERSION } from "../appVersion";

export const useAppVersionCheck = () => {
  useEffect(() => {
    const storedVersion = localStorage.getItem("app_version");

    if (storedVersion && storedVersion !== APP_VERSION) {
      localStorage.setItem("app_version", APP_VERSION);
      window.location.reload();
    }

    if (!storedVersion) {
      localStorage.setItem("app_version", APP_VERSION);
    }
  }, []);
};
